import React, {useState, useEffect} from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { Tag, Table, Button } from "antd";
import { DoubleLeftOutlined, FilterFilled } from '@ant-design/icons';
import styled from "styled-components";
import moment from 'moment';

import { getData } from '../../config/api-connect';

function PhonePeList() {
  const location = useLocation();
  const navigate = useNavigate();

  const [venueId, setVenueId] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();

  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [filteredCount, setFilteredCount] = useState(data.length);
  const [pagination, setPagination] = useState({
                                                current: 1,
                                                pageSize: 25,
                                              });

  const formatted = moment(`${year}-${month}`, "YYYY-MM").format("MMMM YYYY");

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    setVenueId(params.get("venue_id"));
    setMonth(params.get("month"));
    setYear(params.get("year"));
  }, [location.search]);

  useEffect(() => {
    if(month && year){
      getPhonePeEntries();
    }
  }, [venueId, month, year]);

  const getPhonePeEntries = () => {
    setLoader(true);
    getData(`/finance/get_venue_wise_phonepe_entries/?venue_id=${venueId}&month=${month}&year=${year}`)
    .then(response =>{
      setData(response.result)
      setFilteredCount(response.result.length)
      setLoader(false)
    })
    .catch(error => {
      setLoader(false)
      alert(error.message);
    });
  }  
  
  const handleTableChange = (pager, filters, sorter, extra) => {
    setPagination({
      ...pagination,
      current: pager.current,
      pageSize: pager.pageSize,
    });

    setFilteredCount(extra.currentDataSource.length);
  };

  const columns = [
    {
      title: "Store Name",
      dataIndex: "store_name",
    },
    {
      title: "Collected Date",
      dataIndex: "collected_date",
      align: "center",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      align: "right",
      render: (value) => Math.round(value).toLocaleString("en-IN"),
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      align: "center",
    },
    {
      title: "Status",
      key: "status",
      align: "center",

      filters: [
        { text: "Fully Processed", value: "full" },
        { text: "Partially Processed", value: "partial" },
        { text: "Unprocessed", value: "none" },
      ],

      filterIcon: (filtered) => (
        <FilterFilled style={{ color: "white" }} />
      ),

      onFilter: (value, record) => {
        const { amount, processed_amount } = record;

        if (!processed_amount || processed_amount === 0) {
          return value === "none";
        } else if (processed_amount < amount) {
          return value === "partial";
        } else {
          return value === "full";
        }
      },

      render: (_, record) => {
        const { amount, processed_amount } = record;

        let text = "";
        let color = "";

        if (!processed_amount || processed_amount === 0) {
          text = "Unprocessed";
          color = "red";
        } else if (processed_amount < amount) {
          text = "Partially Processed";
          color = "orange";
        } else {
          text = "Fully Processed";
          color = "green";
        }

        return <Tag color={color}>{text}</Tag>;
      },
    }
  ];

  return (
    <div style={{ padding: 20 }}>
      <PageHeader>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button type="link" icon={<DoubleLeftOutlined />} onClick={() => navigate(-1)} style={{ marginRight: 8 }} />
          <PageTitle>PhonePe Entries {formatted}</PageTitle>
        </div>
      </PageHeader>

      <div style={{ marginBottom: 5, textAlign: 'center' }}>
        Showing {filteredCount} records
      </div>

      <div className="summary-table-wrapper">
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          pagination={{
            ...pagination,
            showSizeChanger: true,
            pageSizeOptions: ["10", "25", "50", "100"],
          }}
          onChange={handleTableChange}
          loading={loader}
        />
      </div>

    </div>
  )
}

export default PhonePeList;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 15px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
`;

export const PageTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1565c0;
`;